import { render, staticRenderFns } from "./m-new-signatario.vue?vue&type=template&id=037ca450&"
import script from "./m-new-signatario.vue?vue&type=script&lang=js&"
export * from "./m-new-signatario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports